import React from "react";
import Projects from "../../components/projects/Projects";

function ProjectsPage() {
  return <Projects />;
}

export default ProjectsPage;
